import React, { useState } from "react";
import { Link } from "react-router-dom";

import logo from "../Images/brand/logo.png"
import logo_sweet_bitter from "../Images/sweet-bitter.png"
import logo_compounds from "../Images/virtuous_compounds.png"


function Compounds (){

    const [inputSmile, setInputSmile] = useState("");
    const [inputFile, setInputFile] = useState(false);

    function insertSmile(event){
        setInputSmile(event.target.value)
    }

    function showFile (e) {
        e.preventDefault()
        const reader = new FileReader()
        reader.onload = async (e) => { 
          const text = (e.target.result)
          //console.log(text)
          setInputFile(true)
          setInputSmile(text)
        };
        reader.readAsText(e.target.files[0])
    }

    function deleteFile () {
        setInputFile(false)
        setInputSmile("")
    }


    return <>
    <section className="flex flex-col h-full antialiased bg-neutral-800">
        <header className="sticky top-0 z-50 bg-white md:px-24 drop-shadow-md">
            <div className="flex flex-col items-center justify-between gap-4 md:flex-row p-5">
                <a href="/">
                    <img className="w-40" src={logo} alt="Virtuous LOGO" />
                </a>
                <a href="/" className="flex items-center gap-4 cta cta-primary">
                    <p>ALL TOOLS</p>
                    <i className="ph-caret-right"></i>
                </a>
            </div>
        </header>


        <main className="container relative flex flex-col flex-auto gap-8 p-8 mx-auto my-8 md:p-16 card">
            {/*Action Top*/}
            <div className="flex flex-col justify-center gap-4 md:flex-row">
            <div className="flex flex-row gap-4">
                <img src={logo_compounds} alt="Virtuous Taste prediction"
                    className="w-20 h-20 p-4 bg-gray-100 rounded-full md:h-30 md:w-30" />
                <img src={logo_sweet_bitter} alt="bitter-sweet"
                    className="w-20 h-20 p-4 rounded-full md:h-40 md:w-40 bg-gray-100/50" />
            </div>
            <div>
                <h1 className="font-bold uppercase ">Virtuous Taste prediction</h1>
                <h2 className="font-bold text-gray-500 uppercase ">Virtuous Bitter/Sweet</h2>
                <p className="text-gray-500">Informed classifier to predict the sweet or bitter taste <br />of molecular compounds via
                    Explainable Machine Learning</p>
            </div>
        </div>
            {/*Input*/}
            <div className="flex flex-col w-full gap-4 mx-auto mt-5 space-y-6 lg:w-2/3">
                <div className="container grid gap-2 p-2 mx-auto mt-4 bg-gray-100/50 rounded-3xl md:grid-cols-2 lg:grid-cols-2 ">
                    <p className="mb-4 text-lg font-bold text-center col-span-full">Taste prediction</p>
                    {/*tool taste-selector*/}
                    <a href="bitter-sweet.html" className="w-full p-4 taste-selector taste-selector-active">
                        <div className="flex items-center justify-center gap-4">
                            <h2 className="font-bold uppercase ">Bitter/sweet</h2>
                        </div>
                    </a>
                    {/*tool taste-selector*/}
                    <a  href="http://food.virtuoush2020.com:19009/#/virtuous-umami" target="_blank" className="w-full p-4 taste-selector">
                        <div className="flex items-center justify-center gap-4">
                            <h2 className="font-bold uppercase ">Umami</h2>
                        </div>
                    </a>
                </div>
                {/*Text area*/}
                <div>
                    <label htmlFor="smiles" className="label">Write compound*:</label>
                    <textarea id="smiles" rows="5" spellCheck="false" value={inputSmile} onChange={insertSmile}
                        className="block w-full p-2 text-sm border rounded-lg text-neutrals-900 bg-neutrals-50 border-neutrals-300 focus:ring-primary-500 focus:border-primary-500"
                        placeholder="MILES, FASTA, Inchi, Smarts or pubchem compound."></textarea>
                </div>
                <div className="flex">
                    <hr className="w-full" />
                    <p className="px-8 mx-auto -mt-2 font-bold">OR</p>
                    <hr className="w-full" />
                </div>
                <div className="space-y-6">
                    {/*input*/}
                    <div className="w-full">
                        <div className="flex justify-between">
                            <label className="label" htmlFor="input_file">Upload a file containing compounds*</label>
                            <a className="flex space-x-2 link" href="./assets/txt/demo-compounds.txt">
                                <p>Download example file</p> <i className="text-xl ph-arrow-square-down animate-pulse"></i>
                            </a>
                        </div>
                    </div>
                    {/*Drop file*/}
                    <div className="flex items-center justify-center w-full">
                        <label htmlFor="dropzone-file"
                            className="flex flex-col items-center justify-center w-full border-2 rounded-lg cursor-pointer h-30 group border-neutrals-100 bg-neutrals-50 hover:bg-neutrals-100 animation-smooth">
                            <div className="flex flex-col items-center justify-center pt-5 pb-6">

                                {inputFile ? <div  className="text-center">
                                    <svg className="mb-6" xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="#000000" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"></rect><path d="M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z" fill="none" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></path><polyline points="152 32 152 88 208 88" fill="none" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></polyline><line x1="96" y1="136" x2="160" y2="136" fill="none" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></line><line x1="96" y1="168" x2="160" y2="168" fill="none" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></line></svg>
                                        <div className="flex">
                                            <p className="mb-2 text-sm text-neutrals-500 font-semibold text-center">File uploaded</p>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#000000" viewBox="0 0 256 256" onClick={deleteFile} onChange={(e) => e.preventDefault()}>
                                                <rect width="100" height="100" fill="none"></rect>
                                                    <line x1="200" y1="56" x2="56" y2="200" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></line>
                                                    <line x1="200" y1="200" x2="56" y2="56" stroke="#000000" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"></line>
                                            </svg>
                                        
                                        </div>
                                    </div>
                                :
                                 <div className="text-center">
                                    <svg className="mb-8 group-hover:rotate-180 animation-smooth text-primary mx-auto" width="90"
                                        height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M45.5 89.25C69.6625 89.25 89.25 69.6625 89.25 45.5C89.25 21.3375 69.6625 1.75 45.5 1.75C21.3375 1.75 1.75 21.3375 1.75 45.5C1.75 69.6625 21.3375 89.25 45.5 89.25Z"
                                        fill="white" stroke="#A2A2A6" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" strokeDasharray="4 4" />
                                    <path d="M63 45.5L45.5 28L28 45.5" stroke="currentColor" strokeWidth="2"
                                        strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M45.5 63V28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" />
                                </svg>
                                    <p className="mb-2 text-sm text-neutrals-500 text-center"><span className="font-semibold">Click to upload</span></p>
                                    <p className="text-xs text-neutrals-500">TXT, JSON, .... (MAX. 800x400px)</p>
                                    <input className="hidden" id="dropzone-file" type="file"  onChange={(e) => showFile(e)} />
                                 </div>   
                                }

                            </div>

                            
                        </label>
                    </div>
                </div>
                
                {inputFile ?
                    <div></div>
                :
                    <div className="p-8 border-2 text-primary-600 bg-primary-100 rounded-xl border-primary-600">
                        <div className="flex items-center gap-2 mb-2">
                            <i className="text-4xl ph-warning-octagon text-primary-600"></i>
                            <h2>Attention!</h2>
                        </div>
                        <p className="text-lg">*Each query compound must be write in a different line:</p>
                        <p className="text-sm font-bold">N=C(N)NCCC[C@H](N)C(=O)N[C@@H](CCCCN)C(=O)N[C@@H](CCC(=O)O)C(=O)O
                            <br />GNPDIEHP
                        </p>
                    </div>
                }
            </div>
            
            {/*Action bottom*/}
            <div className="mx-auto">
                <Link className="cta cta-primary" to={inputSmile !== "" ? "/result" : "#"}  state={inputSmile}>
                        Analyze
                </Link>
            </div>
        </main>
    </section>
    </>;
}

export default Compounds;